"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperAppMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "doubleRegistration",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "appLevel",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "callType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "bytes4",
                name: "agreementSelector",
                type: "bytes4",
            },
        ],
        name: "NoopEvent",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionAgreementRevert",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionAlteringCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionAssert",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallActionNoop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallActionNoopThroughAux",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallActionRevert",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallActionWithInvalidCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallAgreementWithInvalidCtx",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallAgreementWithoutCtx",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallAppActionWithoutCtx",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionCallBadAction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "expectedMsgSender",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionExpectMsgSender",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionNoop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionPingAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract AgreementMock",
                name: "agreement",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "ping",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionPingAgreementThroughAux",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionReturnEmptyCtx",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionRevert",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "actionRevertWithReason",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "target",
                type: "address",
            },
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum SuperAppMock.NextCallbackActionType",
                name: "actionType",
                type: "uint8",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "setNextCallbackAction",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        name: "tryRegisterApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SuperAppMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, configWord, doubleRegistration, overrides) {
        return super.deploy(host, configWord, doubleRegistration, overrides || {});
    }
    getDeployTransaction(host, configWord, doubleRegistration, overrides) {
        return super.getDeployTransaction(host, configWord, doubleRegistration, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperAppMock__factory = SuperAppMock__factory;
SuperAppMock__factory.bytecode = _bytecode;
SuperAppMock__factory.abi = _abi;
//# sourceMappingURL=SuperAppMock__factory.js.map